import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './layout-styles.css';

const navItems = [
  {
    path: '/callcenterV2',
    label: 'Monitoramento',
    exact: true,
  },
  {
    path: '/callcenterV2/dashboard',
    label: 'Dashboard',
  },
  {
    path: '/callcenterV2/history',
    label: 'Histórico',
  },
  {
    path: '/callcenterV2/reports',
    label: 'Relatórios',
  },
  {
    path: '/callcenterV2/queues',
    label: 'Filas',
  },
  {
    path: '/callcenterV2/agents',
    label: 'Agentes',
  },
  {
    path: '/callcenterV2/skills',
    label: 'Skills',
  },
];

const VISIBILITY_KEY = 'callcenterV2_visibility';
const DEFAULT_VISIBILITY = {
  header: true,
  kpiPrimary: true,
  kpiSecondary: true,
  queuesPanel: true,
  callsPanel: true,
  agentsPanel: true,
};

const visibilityLabels = {
  header: 'Cabeçalho',
  kpiPrimary: 'KPIs Principais',
  kpiSecondary: 'KPIs Secundários',
  queuesPanel: 'Painel de Filas',
  callsPanel: 'Painel de Chamadas',
  agentsPanel: 'Painel de Atendentes',
};

function CallcenterV2Layout({ children }) {
  const location = useLocation();
  const [showSettings, setShowSettings] = useState(false);
  const [visibility, setVisibility] = useState(DEFAULT_VISIBILITY);

  const isMonitoringPage = location.pathname === '/callcenterV2';

  useEffect(() => {
    try {
      const saved = localStorage.getItem(VISIBILITY_KEY);
      if (saved) {
        setVisibility({ ...DEFAULT_VISIBILITY, ...JSON.parse(saved) });
      }
    } catch (e) {}
  }, []);

  const toggleVisibility = (key) => {
    setVisibility((prev) => {
      const updated = { ...prev, [key]: !prev[key] };
      try {
        localStorage.setItem(VISIBILITY_KEY, JSON.stringify(updated));
        window.dispatchEvent(new CustomEvent('ccv2-visibility-change', { detail: updated }));
      } catch (e) {}
      return updated;
    });
  };

  const isActive = (item) => {
    if (item.exact) {
      return location.pathname === item.path;
    }
    return location.pathname.startsWith(item.path);
  };

  return (
    <div className="ccv2-shell">
      <div className="ccv2-topbar">
        <div className="ccv2-topbar-header">
          <div className="ccv2-topbar-title-wrapper">
            <h1 className="ccv2-topbar-title">Call Center</h1>
            <span className="ccv2-topbar-version">V2</span>
          </div>
          <p className="ccv2-topbar-subtitle">Monitoramento e gestão de filas em tempo real</p>
        </div>
        <div className="ccv2-topbar-actions">
          <Link to="/callcenter" className="ccv2-back-link">
            ← Voltar para V1
          </Link>
        </div>
      </div>

      <nav className="ccv2-subnav">
        <div className="ccv2-subnav-scroll">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`ccv2-subnav-item ${isActive(item) ? 'active' : ''}`}
            >
              {item.label}
            </Link>
          ))}
        </div>

        {isMonitoringPage && (
          <div className="ccv2-settings-wrapper">
            <button 
              className="ccv2-settings-toggle"
              onClick={() => setShowSettings(!showSettings)}
              title="Configurar visibilidade"
            >
              ⚙️ Exibição
            </button>
            {showSettings && (
              <div className="ccv2-settings-dropdown">
                {Object.keys(DEFAULT_VISIBILITY).map((key) => (
                  <label key={key} className="ccv2-settings-item">
                    <input
                      type="checkbox"
                      checked={visibility[key]}
                      onChange={() => toggleVisibility(key)}
                    />
                    <span>{visibilityLabels[key]}</span>
                  </label>
                ))}
              </div>
            )}
          </div>
        )}
      </nav>

      <main className="ccv2-content">
        {children}
      </main>
    </div>
  );
}

export default CallcenterV2Layout;
